import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import { Delete, CloseOutlined } from "@material-ui/icons/";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateMultipleDates from "./CreateMultipleDates";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { set } from "react-hook-form";
import ImageAttachment from "../../biztran_controls/ImageAttachment";
// import Loader from "../../biztran_controls/Loader";


Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

//var defaultdate = Moment ()

// const DCD = ADDDATE(curdate(), INTERVAL 4 DAY);

// const today = Moment(new Date().addDays(60)).format("DD/MMM/YYYY");


const EditProduct = (props) => {
  const classes = useStyles();
  const [response, fetchData] = UseFetchData();
  const [isOpen, setOpen] = useState(false);
  const [isTwoopen, setisTwoopen] = useState(false);
  const [Mode, setMode] = useState('');
  const [deleteresponse, DeleteSalesOrderdtlsData] = UseFetchData();
  const [Productresponse, FetchProduct] = UseFetchData();
  const [ModelCode, setModelCode] = useState("");
  const [NetWeight, setNetWeight] = useState('');
  const [Seq, setSeq] = useState("");
  const [Currency, setCurrency] = useState();
  const [ConversionRate, setConversionRate] = useState("");
  const [ConversionResopnse, fetchConversion] = UseFetchData();
  const [ProductSKUID, setProductSKUID] = useState('');
  const [StateName, setStateName] = useState();
  const [Description, setDescription] = useState('');
  const [Rate, setRate] = useState(0);
  const [RateINR, setRateINR] = useState(0);
  //// debugger;
  const [DeliveryDate, setDeliveryDate] = useState(Moment(new Date().addDays(4)).format("DD/MMM/YYYY"));
  const [ValidUpTo, setValidUpTo] = useState(
    Moment(new Date().addDays(4)).format("YYYY-MM-DD")
  );
  // const [DelDate, setDelDate] = useState(
  //   Moment(new Date().addDays(4)).format("YYYY-MM-DD")
  // );
  const [GstAmount, setGstAmount] = useState();
  const [SGstAmount, setSGstAmount] = useState();
  const [IGstAmount, setIGstAmount] = useState();
  const [GstPer, setGstPer] = useState();
  const [CgstPer, setCgstPer] = useState();
  const [SgstPer, setSgstPer] = useState();
  const [IgstPer, setIgstPer] = useState();
  const [Quantity, setQuantity] = useState(0);
  const [ConvFactor, setConvFactor] = useState();
  const [DiscountPer, setDiscountPer] = useState();
  const [DiscountAmt, setDiscountAmt] = useState();
  const [Total, setTotal] = useState();
  const [TotalINR, setTotalINR] = useState(0);
  const [DisableDeliveryDate, setDisableDeliveryDate] = useState(false);
  const [DisableIgstPer, setDisableIgstPer] = useState(false);
  // const [DisableIgstAmt, setDisableIgstAmt] = useState(false);
  const [DisableCgstPer, setDisableCgstPer] = useState(false);
  // const [DisableCgstAmt, setDisableCgstAmt] = useState(false);
  const [DisableSgstPer, setDisableSgstPer] = useState(false);
  // const [DisableSgstAmt, setDisableSgstAmt] = useState(false);
  const [ImagePath, setImagePath] = useState('');
  const [Amount, setAmount] = useState(Rate * Quantity);
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);
  const [DisablecloseBtn, setDisablecloseBtn] = useState(false);
  const [flagPer, setflagPer] = useState(false);
  const [flagAmt, setflagAmt] = useState(false);
  const [DisableSaveBtn, setDisableSaveBtn] = useState(false);




  const validationSchema = Yup.object({
    ModelCode: Yup.string().required("Required!"),
    Quantity: Yup.string().required("Required!"),
    Rate: Yup.string().required("Required!"),
  });

  const OnDelete = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("SalesOrderDtlsID", props.SalesOrderDtlsID);
    setLoading(true);
    DeleteSalesOrderdtlsData("SalesOrder/DeleteSalesOrderDtls", bodyFormData);
  };

  const AddNew = () => {
    setOpen(true);
    setMode('Insert');
    setDisableDeliveryDate(true);
  }

  const CalculateDiscountPer = (e) => {
    // debugger;
    if (Currency != "INR") {
      const Rates = (Number(Rate) + Number(GstAmount) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
      setDiscountPer(e.target.value);
      const Dis = (e.target.value) / 100;
      const DisAmt = Dis * Rate;
      const FinalRate = (Number(Rates) - Number(DisAmt)).toFixed(2);
      const FinalAmount = FinalRate * Quantity;
      setDiscountAmt(DisAmt.toFixed(2));
      console.log("total4:", Total);
    }
    else {
      const RateI = (Number(RateINR) + Number(GstAmount) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
      setDiscountPer(e.target.value);
      const Dis = (e.target.value) / 100;
      const DisAmt = Dis * RateINR;
      const FinalRate = (Number(RateI) - Number(DisAmt)).toFixed(2);
      const FinalAmount = FinalRate * Quantity;
      setDiscountAmt(DisAmt.toFixed(2));
      console.log("total4:", TotalINR);
    }
  }

  const CalculateDiscountAmt = (e) => {
    if (Currency != "INR") {
      const Rates = (Number(Rate) + Number(GstAmount) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
      setDiscountAmt(e.target.value);
      const FinalRate = Rates - (e.target.value);
      const DisAmt = (e.target.value) / Rate;
      const Dist = DisAmt * 100;
      const FinalAmount = FinalRate * Quantity;
      setDiscountPer(Dist.toFixed(2));
      console.log("total3:", Total);
    }
    else {
      const RateI = (Number(RateINR) + Number(GstAmount) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
      setDiscountAmt(e.target.value);
      const FinalRate = RateI - (e.target.value);
      const DisAmt = (e.target.value) / RateINR;
      const Dist = DisAmt * 100;
      const FinalAmount = FinalRate * Quantity;
      setDiscountPer(Dist.toFixed(2));
      console.log("total3:", TotalINR);
    }
  }

  useEffect(() => {
    if (deleteresponse.Response === true) {
      // alert("Data Deleted Succesfully.");
      props.setOpen(false);
      props.getByIDData()
      setLoading(false);

    } else if (deleteresponse.Response === false) {
      alert("Failed.");
      setLoading(false);

    }
  }, [deleteresponse]);


  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };


  const onSubmit = () => {
    var bodyFormData = new FormData();
    var cgstP = 0;
    var cgst = 0;
    var sgstP = 0;
    var sgst = 0;
    var IgstP = 0;
    var Igst = 0;
    debugger
    bodyFormData.append("SalesOrderDtlsID", props.SalesOrderDtlsID);
    bodyFormData.append("SalesOrderID", props.SOID);
    bodyFormData.append("Seq", Seq);
    // bodyFormData.append("ProductID", "");
    bodyFormData.append("ProductSKUID", ProductSKUID);
    bodyFormData.append("Description", Description);
    bodyFormData.append("Quantity", Quantity);
    bodyFormData.append("Rate", Rate);
    bodyFormData.append("RateINR", RateINR);
    bodyFormData.append("DiscountPer", DiscountPer);
    bodyFormData.append("DiscountAmt", DiscountAmt);
    // bodyFormData.append("CurrencyID", CurrencyID);
    bodyFormData.append("Currency", Currency);
    bodyFormData.append("ConvFactor", ConversionRate);
    bodyFormData.append("CUrrencyRate", "0");
    // bodyFormData.append("Amount", Amount);
    if (Currency == "INR") {
      bodyFormData.append("CgstPer", CgstPer);
      bodyFormData.append("CgstAmt", GstAmount);
      bodyFormData.append("SgstPer", SgstPer);
      bodyFormData.append("SgstAmt", SGstAmount);
      bodyFormData.append("IgstPer", IgstPer);
      bodyFormData.append("IgstAmt", IGstAmount);
    } else {
      bodyFormData.append("CgstPer", cgstP);
      bodyFormData.append("CgstAmt", cgst);
      bodyFormData.append("SgstPer", sgstP);
      bodyFormData.append("SgstAmt", sgst);
      bodyFormData.append("IgstPer", IgstP);
      bodyFormData.append("IgstAmt", Igst);
    }
    bodyFormData.append("DeliveryDate", ValidUpTo);
    bodyFormData.append("NetWeight", NetWeight);
    bodyFormData.append("TotalAmount", Total);
    bodyFormData.append("TotalAmountINR", TotalINR);
    setLoading(true);
    setDisablecloseBtn(true);
    setDisableSaveBtn(true);
    fetchData("SalesOrder/AddProduct", bodyFormData);
  };

  const PopulatesData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("Quantity", Quantity);
    bodyFormData.append("DeliveryDate", ValidUpTo);
    setLoading(true);
    fetchData("SalesOrder/AddProduct", bodyFormData);
  }


  useEffect(() => {
    //// debugger;
    if (ConversionResopnse !== undefined) {
      setLoading(false);
      if (ConversionResopnse["ConversionData"] !== undefined) {
        setCurrency(ConversionResopnse["ConversionData"][0]["Currency"]);
        setConversionRate(ConversionResopnse["ConversionData"][0]["ConversionRate"]);
      }
    }
  }, [ConversionResopnse]);

  useEffect(() => {
    GetConversionDate();
  }, []);

  const GetConversionDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("SalesOrderID", props.SOID);
    setLoading(false);
    fetchConversion("SalesOrder/ConversionData", bodyFormData);
  }

  useEffect(() => {
    if (response.Response === true) {
      // alert("Data Saved Succesfully.");
      props.setOpen(false);
      props.getByIDData()
      setLoading(false);
      // DisableSaveBtn(true);
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
        setLoading(false);

      } else {
        alert("Failed.");
        setLoading(false);
        // setDisableSaveBtn(false);

      }
    }
  }, [response]);

  const PopulateData = () => {
    var bodyFormData = new FormData();
    // debugger;
    bodyFormData.append("SalesOrderDtlsID", props.SalesOrderDtlsID);
    setLoading(true);
    FetchProduct("SalesOrder/SalesOrderDtlsByID", bodyFormData);
  };

  useEffect(() => {
    PopulateData();
  }, []);

  useEffect(() => {
    // debugger;
    if (Productresponse.length > 0) {
      setLoading(false);
      setModelCode(Productresponse[0].ModelCode);
      setSeq(Productresponse[0].Seq);
      setNetWeight(Productresponse[0].NetWeight);
      setProductSKUID(Productresponse[0].ProductSKUID);
      console.log('ProductSkuID:', Productresponse[0].ProductSKUID)
      setDescription(Productresponse[0].Description);
      setQuantity(Productresponse[0].Quantity);
      // setCurrencyID(Productresponse[0].CurrencyID);
      // console.log('CurrencyID:', Productresponse[0].CurrencyID)
      setCurrency(Productresponse[0].Currency);
      setRate(Productresponse[0].Rate);
      setRateINR(Productresponse[0].RateINR);
      setAmount(Productresponse[0].Amount);
      setImagePath(Productresponse[0].FilePath);
      setDiscountPer(Productresponse[0].DiscountPer);
      setDiscountAmt(Productresponse[0].DiscountAmt);
      setTotal(Productresponse[0].TotalAmount);
      setTotalINR(Productresponse[0].TotalAmountINR);
      setGstAmount(Productresponse[0].GstAmount);
      setSGstAmount(Productresponse[0].SGstAmount);
      setIGstAmount(Productresponse[0].IGstAmount);
      setDeliveryDate(Moment(Productresponse[0].DeliveryDate).format("YYYY-MMM-DD"))
      // debugger;
      setCgstPer(Productresponse[0].CgstPer);
      setSgstPer(Productresponse[0].SgstPer);
      setIgstPer(Productresponse[0].IgstPer);
      setStateName(Productresponse[0].StateName);
      if (Productresponse[0].ConvFactor != 1) {
        setDisableIgstPer(true);
        setIgstPer(0);
        setDisableCgstPer(true);
        setCgstPer(0);
        setGstAmount(0);
        setDisableSgstPer(true);
        setSGstAmount(0);
        setSgstPer(0);
      }
      else if (Productresponse[0].StateName === "Maharashtra") {
        setDisableIgstPer(true);
        setIgstPer(0);
        setIGstAmount(0);
      }
      else {
        setDisableCgstPer(true);
        setCgstPer(0);
        setGstAmount(0);
        setDisableSgstPer(true);
        setSGstAmount(0);
        setSgstPer(0);
      }
    }
  }, [Productresponse]);


  useEffect(() => {
    setAmount(Quantity * Rate);
    debugger;
    var DisAmt = 0;
    var DisAMTINR = 0;
    var Dis = 0;
    var Dist = 0;
    var Rate1 = 0;
    var Rate2 = 0;
    if (flagPer == true && flagAmt == false) {
      Dis = (DiscountPer) / 100;
      DisAmt = (Dis * Rate) * (Quantity);
      DisAMTINR = (Dis * RateINR) * (Quantity);
      if (Currency != "INR") {
        setDiscountAmt(DisAmt.toFixed(2));
        Rate1 = (Quantity * Number(Rate)) - (DisAmt);
        Rate2 = (Quantity * Number(RateINR)) - (DisAMTINR);
      } else {
        setDiscountAmt(DisAMTINR.toFixed(2));
        Rate2 = (Quantity * Number(RateINR)) - (DisAMTINR);
        Rate1 = (Quantity * Number(Rate)) - (DisAmt);


      }
      // setDiscountPer(DiscountPer);

    }
    else if (flagPer !== true && flagAmt !== false) {
      if (Currency != "INR") {
        DisAmt = (DiscountAmt) / (Rate * Quantity);
        Dist = (DisAmt * 100);
        setDiscountPer(Dist.toFixed(2));
        // setDiscountAmt(DiscountAmt.toFixed(2));

      } else {
        DisAMTINR = (DiscountAmt) / (RateINR * Quantity);
        Dist = (DisAMTINR * 100);
        setDiscountPer(Dist.toFixed(2));
        // setDiscountAmt(DiscountAmt.toFixed(2));
      }
      Rate1 = (Quantity * Number(Rate)) - (DiscountAmt);
      Rate2 = (Quantity * Number(RateINR)) - (DiscountAmt);


    } else {
      Dis = (DiscountPer) / 100;
      DisAmt = (Dis * Rate) * (Quantity);
      DisAMTINR = (Dis * RateINR) * (Quantity);
      if (Currency != "INR") {
        setDiscountAmt(DisAmt.toFixed(2));
        Rate1 = (Quantity * Number(Rate)) - (DisAmt);
        if (flagPer == true && flagAmt == false) {
          Rate2 = (Quantity * Number(RateINR)) - (DisAMTINR);
        }
        else if (flagPer !== true && flagAmt !== false) {
          Rate2 = (Quantity * Number(RateINR)) - (DiscountAmt);
        }
        else {
          Rate2 = (Quantity * Number(RateINR)) - (DisAMTINR);
        }
      } else {
        setDiscountAmt(DisAMTINR.toFixed(2));
        Rate2 = (Quantity * Number(RateINR)) - (DisAMTINR);

        if (flagPer == true && flagAmt == false) {
          Rate1 = (Quantity * Number(Rate)) - (DisAmt);
        }
        else if (flagPer !== true && flagAmt !== false) {
          Rate1 = (Quantity * Number(Rate)) - (DiscountAmt);
        }
        else {
          Rate1 = (Quantity * Number(Rate)) - (DisAmt);

        }
      }
    }

    setTotal(Rate1.toFixed(2));

    if (Currency != "INR") {
      setTotalINR(Rate2.toFixed(2));
    }
    else {
      const GST = CgstPer / 100;
      const GSTAmt = Rate2 * GST;
      const FinalRate = (Number(Rate2) + Number(GSTAmt)).toFixed(2);
      const FinalAmount = FinalRate * Quantity;
      setGstAmount(GSTAmt.toFixed(2));

      const GST1 = SgstPer / 100;
      const GSTAmt1 = Rate2 * GST1;
      const FinalAmount1 = FinalRate * Quantity;
      setSGstAmount(GSTAmt1.toFixed(2));


      const GST2 = IgstPer / 100;
      const GSTAmt2 = Rate2 * GST2;
      const FinalAmount2 = FinalRate * Quantity;
      setIGstAmount(GSTAmt2.toFixed(2));


      setTotalINR((Rate2 + (GSTAmt2 + GSTAmt1 + GSTAmt)).toFixed(2));

    }
  }, [Rate, RateINR, Quantity, CgstPer, IgstPer, SgstPer, DiscountPer, DiscountAmt]);

  return (
    <div>
      {/* {
        loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
      <Formik
        initialValues={{
          ModelCode: ModelCode,
          Seq: Seq,
          NetWeight: NetWeight,
          Description: Description,
          Rate: Rate,
          RateINR: RateINR,
          // DelDate: DelDate,
          DeliveryDate: DeliveryDate,
          ValidUpTo: ValidUpTo,
          Quantity: Quantity,
          Amount: Amount,
          ConversionRate: ConversionRate,
          Currency: Currency,
          DiscountPer: DiscountPer,
          DiscountAmt: DiscountAmt,
          Total: Total,
          TotalINR: TotalINR,
          GstPer: GstPer,
          CgstPer: CgstPer,
          SgstPer: SgstPer,
          IgstPer: IgstPer,
          GstAmount: GstAmount,
          SGstAmount: SGstAmount,
          IGstAmount: IGstAmount
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid spacing={1} container direction="row" >
                <Grid spacing={1} item xs={8} container>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Model Code"
                      name="ModelCode"
                      disabled
                      onChange={(e) => setModelCode(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Seq"
                      name="Seq"
                      onChange={(e) => setSeq(e.target.value)}
                    />
                  </Grid>
                  <Grid spacing={1} container direction="row">
                    <Grid item xs={12}>
                      <BiztranControlsFormik
                        autoFocus="autofocus"
                        control="textarea"
                        type="text"
                        label="Description"
                        name="Description"
                        ref={ref}
                        value={Description}
                        onChange={(e) => {
                          setDescription(e.target.value)
                          handleChange()
                        }
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Quantity"
                        name="Quantity"
                        onChange={(e) => setQuantity(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="RateINR"
                        name="RateINR"
                        onChange={(e) => setRateINR(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Rate"
                        name="Rate"
                        onChange={(e) => setRate(e.target.value)}
                      />
                    </Grid>
                    {/* <Grid item xs={4}> */}
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="DiscountPer"
                        name="DiscountPer"
                        // onChange={(e) => CalculateDiscountPer(e)}
                        onChange={(e) => {
                          setDiscountPer(e.target.value)
                          setflagPer(true)
                          setflagAmt(false)
                        }
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="DiscountRate"
                        name="DiscountAmt"
                        // onChange={(e) => CalculateDiscountAmt(e)}
                        onChange={(e) => {
                          setDiscountAmt(e.target.value)
                          setflagPer(false)
                          setflagAmt(true)
                        }
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="SGSTPer"
                        name="SgstPer"
                        disabled={DisableSgstPer}
                        onChange={(e) => setSgstPer(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="SGSTAmount"
                        name="SGstAmount"
                        disabled
                        onChange={(e) => setSGstAmount(e.target.value)}
                      />
                    </Grid>
                    {/* <Grid item xs={4}> */}
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="CGSTPer"
                        name="CgstPer"
                        disabled={DisableCgstPer}
                        onChange={(e) => setCgstPer(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="CGSTAmount"
                        name="GstAmount"
                        disabled
                        onChange={(e) => setGstAmount(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="IGSTPer"
                        name="IgstPer"
                        disabled={DisableIgstPer}
                        onChange={(e) => setIgstPer(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="IGSTAmount"
                        name="IGstAmount"
                        disabled
                        onChange={(e) => setIGstAmount(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Net Weight"
                        name="NetWeight"
                        onChange={(e) => setNetWeight(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={6} md={1} sm={2} lg={2} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Currency"
                        name="Currency"
                        disabled
                        onChange={(e) => setCurrency(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Total"
                        name="Total"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="TotalINR"
                        name="TotalINR"
                        disabled
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="date"
                        label="DeliveryDate"
                        name="DeliveryDate"
                        defaultValue={DeliveryDate}
                        disabled={DisableDeliveryDate}
                        onChange={(e) => setDeliveryDate(e.target.value)}
                      />
                    </Grid> */}
                    <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="date"
                        label="DeliveryDate"
                        name="ValidUpTo"
                        defaultValue={ValidUpTo}
                        onChange={(e) => setValidUpTo(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Card className={classes.root}>
                    <CardActionArea onClick={() => { window.open(ImagePath); }}>
                      <CardMedia
                        component="img"
                        //alt={FileName}
                        height="230"
                        image={ImagePath}
                        title="Product"
                      />

                    </CardActionArea>
                  </Card>
                </Grid>
                {/* </Grid> */}
              </Grid>

              <Grid spacing={2} container direction="row">
                <Grid item xs={12}>
                  <div style={{ width: '100%' }}>
                    <a href="javascript:;" onClick={() => { AddNew() }} >Split into Multiple Delivery Dates</a>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                      <BiztranControls.Button
                        text="Update"
                        type="submit"
                        disabled={DisableSaveBtn}
                        startIcon={<SaveIcon />}
                      />
                      <BiztranControls.Button
                        text="Delete"
                        onClick={() => {
                          OnDelete();
                        }}
                        startIcon={<Delete />}
                      />
                      <BiztranControls.Button
                        text="CLOSE"
                        disabled={DisablecloseBtn}
                        startIcon={<CloseOutlined />}
                        onClick={() => { props.setOpen(false); }}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
      <ModalFrame
        title="Split Into Multiple Delivery Dates"
        maxWidth="sm"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
      >
        <CreateMultipleDates
          // ProductID={ProductID}
          SalesOrderDtlsID={props.SalesOrderDtlsID}
          SOID={props.SOID}
          ProductSKUID={ProductSKUID}
          getByIDData={props.getByIDData}
          setOpen={props.setOpen}
          Quantity={Quantity}
          PopulateData={PopulatesData}
          Mode={Mode}
        />
      </ModalFrame>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //   borderRadius: "1rem",
  },
  root: {
    height: '100%',
    width: '100%',
    paddingTop: '7%',
    //paddingTop: '56.25%', // 16:9
  },
}));

export default EditProduct;
